<template>
  <v-parallax
    :src="require('../assets/img/h1bg.png')"
    gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
  >
    <div
      class="d-flex flex-column fill-height justify-center align-center text-white ma-3"
    >
      <h2 class="text-h2 font-weight-thin mb-4 pa-2">ใส่ใจวัยเก๋า</h2>
      <h3 class="subheading">
        วิเคราะห์ความเสี่ยงการล้ม ป้องกันการล้มผู้สูงอายุ ด้วย AI อัจฉริยะ
        <br />
        เทคโนโลยีเฝ้าระวังอุบัติเหตุ ที่ช่วยลดความเสี่ยงและเพิ่มความปลอดภัย
      </h3>
      <v-btn color="primary" class="ma-3 pa-2" to="/thaifrat"
        >เริ่มต้นใช้งาน</v-btn
      >
    </div>
  </v-parallax>

  <v-parallax
    :src="require('../assets/img/h2bg.png')"
    gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
  >
    <div
      class="d-flex flex-column fill-height justify-center align-center text-white ma-3 pa-2"
    >
      <!-- Why Prevention is Important -->
      <v-card class="align-center justify-center d-flex" variant="outlined">
        <v-container>
          <h2
            class=" font-weight-thin align-center justify-center d-flex text-h4"
          >
            ทำไมการป้องกันการล้มถึงสำคัญ?
          </h2>

          <v-row dense class="ma-5 pa-2">
            <v-col cols="4" xs="4" md="4">
              <v-card
                class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1"
                outlined
                max-width="344"
                height="100"
              >
                <p>เมื่อ 1 คนล้ม </p>
              </v-card>
            </v-col>
            <v-col cols="4" xs="4" md="4">
              <v-card
                class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1"
                outlined
                max-width="344"
                height="100"
              >
                <p>หกล้มเพียง 1 ครั้ง </p>
              </v-card>
            </v-col>
            <v-col cols="4" xs="4" md="4">
              <v-card
                class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1"
                outlined
                max-width="344"
                height="100"
              >
                <p>เสียหายมากกว่าที่คิด</p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </v-parallax>

  <!-- Our Solution -->
  <v-parallax :src="require('../assets/img/h5bg.png')">
    
    <div
      class="d-flex flex-column fill-height justify-center align-center ma-3 pa-2"
    >
    <v-card variant="text" color="dark" >
      <h4 class="text-h4  align-center justify-center d-flex">
        ระบบของเรา ทำงานอย่างไร?
      </h4>
      <v-row>
        <v-col cols="6" md="6" sm="6" >
          <v-card class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1 ">
            <v-icon color="primary">mdi-chart-line</v-icon>
            วิเคราะห์ความเสี่ยงเฉพาะบุคคล
          </v-card>

        </v-col>

        <v-col cols="6" md="6" sm="6" >
          <v-card class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1" >
            <v-icon color="primary">mdi-eye</v-icon>
            ตรวจจับด้วย AI & Computer Vision
          </v-card>
        </v-col>
      </v-row>
          <v-row>
        <v-col cols="6" md="6" sm="6" >
          <v-card class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1">
            <v-icon color="primary">mdi-bell</v-icon>
            แจ้งเตือนทันทีผ่านแอปพลิเคชัน
          </v-card>
        </v-col>

        <v-col cols="6" md="6" sm="6" >
          <v-card class="text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1">
            <v-icon color="primary">mdi-chart-bar</v-icon>
            รายงานข้อมูลและแนวโน้มความเสี่ยง
          </v-card>
        </v-col>
      </v-row>
    </v-card>

      <h4
        class="text-h4 font-weight-thin align-center justify-center d-flex pa-4 "
      >
        เสียงจากผู้ใช้งานจริง
      </h4>
      <v-card
        append-icon="mdi-comment-account"
        class="align-center justify-center d-flex pa-2 ma-2 "
      >
        <v-card-text >
          <h5 class="text-sm-h6 font-weight-thin align-center justify-center text-body-1">
            “ตั้งแต่ใช้ระบบนี้ เราสามารถเฝ้าระวังผู้สูงอายุ<br />ได้ดียิ่งขึ้น 
            ลดอุบัติเหตุได้จริง”
          </h5>
          <h5>-<strong>เจ้าหน้าที่ศูนย์ดูแล</strong>-</h5>
          <v-btn color="success" class="mt-3" to="/about">ทดลองใช้งานฟรี 30 วัน</v-btn>
        </v-card-text>
      </v-card>
    </div>
  </v-parallax>
  <!-- Testimonials -->
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Components

export default defineComponent({
  name: "HomeView",

  components: {},
});
</script>
